import fvRenderScript from "./fvRenderScript"
export default class fvRenderMove {
    constructor(renderConfig,system){
        this.rd = renderConfig;
        if(system!==undefined){
            this.system=system._this;
        }
        this.m_fRotate = 3.1415926/180.00013* parseFloat(this.rd.rotate); //跟draw的精度一样
        if(this.rd.color){
            this.colorNum = this.rd.color.length;
        }
        this.oldrect="";
        this.m_pPotPtr=[];
        this.m_nPotNum=0;
        this.color=[];
        this.m_color=[];
    }
    rend(canvas, rect,obj) {
        if(obj==undefined){
            console.warn("渲染对象不能为空");
            return;
        }
        this.m_color = this.rd.color.slice();
        this.colorNumS = {value:this.colorNum};
        var fRotate = this.m_fRotate;
        var color = new Array(10);
        this.render = new fvRenderScript();
        this.render.InitColor(color,this.colorNumS,this.rd.colorGrade,this.rd.color.slice());	//初始化颜色
        //把角度转化为2π内
        var tempObj = {
            value: fRotate
        }
        this.render.RotateTo2Pi(tempObj);

        fRotate = tempObj.value;
        //把一个圆周角分成8份，判断角度在哪一个区域里
        var ntemp = parseInt(fRotate / (3.1415926 / 4.0));
        if (ntemp > 2 && ntemp < 7)//区域大于4，颜色交换
        {
            var tempcolor;
            for (var i = 0; i < this.colorNumS.value / 2; i++) {
                tempcolor = color[i];
                color[i] = color[this.colorNumS.value - 1 - i];
                color[this.colorNumS.value - 1 - i] = tempcolor;
            }
        }

        //生成多边形并计算偏移量
        var nSplitAdd;
        var fAddX = 0.0;
        var fAddY = 0.0;
        var nAddMin = 0, nAddMax = 0;
        //var IsW = 0;// ((ntemp + 1) / 2);

        var parm = {
            parm1: nAddMin,
            parm2: nAddMax
        };

        var IsW = ((ntemp + 1)/2)&1;

        this.GetAddMinMax(fRotate,rect,parm,IsW);
        nAddMin = parm.parm1;
        nAddMax = parm.parm2;

        var nSplit = this.render.Split(nAddMax - nAddMin, this.rd.grade);
        if (IsW)		//宽
        {
            fAddX = parseFloat(nAddMax - nAddMin) / parseFloat(nSplit);
            nSplitAdd = parseFloat(fAddX) + 2;
        }else {
            fAddY = parseFloat(nAddMax - nAddMin) / parseFloat(nSplit);
            nSplitAdd = parseFloat(fAddY) + 2;
        }
        var pot = new Array();
        var oldPot = new Array();
        ntemp = ntemp%4;
        switch (ntemp)//区域
        {
            case 0:
                pot[0] = {
                    x:rect.left,
                    y:nAddMin
                };
                pot[1] = {
                    x:rect.right,
                    y:nAddMin - parseInt(rect.width * Math.tan(fRotate))
                };
                pot[2] = {
                    x:pot[1].x, 
                    y:pot[1].y + nSplitAdd
                };
                pot[3] = {
                    x:pot[0].x,
                    y:pot[0].y + nSplitAdd
                };
                break;
            case 1:
                pot[0] = {
                    x:nAddMin + parseInt(rect.height * Math.cos(fRotate) / Math.sin(fRotate)),
                    y:rect.top
                };
                pot[1] = {
                    x:nAddMin,
                    y:rect.bottom + nSplitAdd
                };
                pot[2] = {
                    x:pot[1].x + nSplitAdd,
                    y:pot[1].y
                };
                pot[3] = {
                    x:pot[0].x + nSplitAdd,
                    y:pot[0].y
                };
                break;
            case 2:
                pot[0] = {
                    x:nAddMin,
                    y:rect.bottom
                };
                pot[1] = {
                    x:nAddMin + parseInt(rect.height * Math.cos(fRotate) / Math.sin(fRotate)),
                    y:rect.top
                };
                pot[2] = {
                    x:pot[1].x + nSplitAdd,
                    y:pot[1].y + nSplitAdd
                };
                pot[3] = {
                    x:pot[0].x + nSplitAdd,
                    y:pot[0].y + nSplitAdd
                };
                break;
            case 3:
                pot[0] = {
                    x:rect.right,
                    y:nAddMin - parseInt(rect.width * Math.tan(fRotate))
                };
                pot[1] = {
                    x:rect.left,
                    y:nAddMin
                };
                pot[2] = {
                    x:pot[1].x,
                    y:pot[1].y + nSplitAdd
                };
                pot[3] = {
                    x:pot[0].x,
                    y:pot[0].y + nSplitAdd
                };
                break;
            default:
                break;
        }

        for (var k = 0; k < 4; k++) {//备份多边形点信息
            oldPot[k] = {
                x:pot[k].x,
                y:pot[k].y
            }
        }

        //开始绘图
        var fXoffAll = fAddX;
        var fYoffAll = fAddY;
        var fr, fg, fb, frAdd, fgAdd, fbAdd;
        var colc = 0;
        var oldcolc = -1;
        var nPolyPot;
        //第一种
        for (var i = 0; i < nSplit; i++) {
            colc = parseInt(i * (this.colorNumS.value - 1) / nSplit);
            if (colc != oldcolc) {//这里没有使用双重循环，那样会出现误差
                var rgbArray = color[colc].colorRgb();
                fr = rgbArray[0];
                fg = rgbArray[1];
                fb = rgbArray[2];
                var rgbArray1 = color[colc+1].colorRgb();
                frAdd = parseFloat((rgbArray1[0] - fr) / (parseFloat(nSplit - 1) / (this.colorNumS.value - 1)));
                fgAdd = parseFloat((rgbArray1[1] - fg) / (parseFloat(nSplit - 1) / (this.colorNumS.value - 1)));
                fbAdd = parseFloat((rgbArray1[2] - fb) / (parseFloat(nSplit - 1) / (this.colorNumS.value - 1)));
                oldcolc = colc;
            }
            var tempRGB = "RGB("+parseInt(fr)+","+parseInt(fg)+","+parseInt(fb)+")";
            var tempColor = tempRGB.colorHex();
            if(this.system!==undefined){
                let posint=[];
                for (var i_cur = 1 ;i_cur < pot.length ; i_cur++) {
                    posint.push([parseFloat(pot[i_cur].x),parseFloat(pot[i_cur].y)])
                }
                canvas.innerHTML += ` <path d="M${parseFloat(pot[0].x)} ${parseFloat(pot[0].y)} L${posint} Z" fill="${tempColor}" stroke="${tempColor}" stroke-width="1" />`;
            
            }else{
                canvas.beginPath();
                canvas.fillStyle = tempColor;
                canvas.lineWidth = 1;
                canvas.strokeStyle = tempColor;
                var tempPolyNum = this.colorNumS.value;
                canvas.moveTo(parseFloat(pot[0].x),parseFloat(pot[0].y));
                for(var i_cur = 1 ;i_cur < pot.length ; i_cur++) {
                    canvas.lineTo(parseFloat(pot[i_cur].x), parseFloat(pot[i_cur].y));
                }
                canvas.closePath();
                canvas.stroke();
                canvas.fill();
            }
           
            nPolyPot = 4;
            for (var k = 0; k < 4; k++) {
                pot[k].x = parseFloat(oldPot[k].x) + parseFloat(fXoffAll);
                pot[k].y = parseFloat(oldPot[k].y) + parseFloat(fYoffAll);
            }
            fXoffAll += fAddX;
            fYoffAll += fAddY;
            fr += frAdd;
            fg += fgAdd;
            fb += fbAdd;
        }
    }
    GetAddMinMax(fRotate, rect, parm, IsW) {

        parm.parm1 = 2147483647;
        parm.parm2 = -2147483647;
        var ntemp;
        var cosR = Math.cos(fRotate);
        var sinR = Math.sin(fRotate);
        var pPot = new Array();
        var ptempPot;
        var nNum = 4;
        pPot[0] = {
            x:rect.left,
            y:rect.top
        };
        pPot[1] = {
            x:rect.right,
            y:rect.top
        };
        pPot[2] = {
            x:rect.right,
            y:rect.bottom
        };
        pPot[3] = {
            x:rect.left,
            y:rect.bottom
        };
        ptempPot = pPot;
        if (IsW) {
            for (var i = 0; i < nNum; i++) {
                if (Math.abs(sinR) < 0.0001)
                    ntemp = ptempPot[i].y;
                else
                    ntemp = parseFloat(ptempPot[i].x) + parseFloat(ptempPot[i].y - rect.bottom) * cosR / sinR;
                if (ntemp < parm.parm1)
                    parm.parm1 = ntemp;
                if (ntemp > parm.parm2)
                    parm.parm2 = ntemp;
            }
        }
        else {
            for (var i = 0; i < nNum; i++) {
                if (Math.abs(cosR) < 0.0001)
                    ntemp = ptempPot[i].x;
                else
                    ntemp = parseFloat(ptempPot[i].y) + parseFloat(ptempPot[i].x - rect.left) * sinR / cosR;
                if (ntemp < parm.parm1)
                    parm.parm1 = ntemp;
                if (ntemp > parm.parm2)
                    parm.parm2 = ntemp;
            }
        }
        parm.parm1--;
        parm.parm2++;
    }
}


// WEBPACK FOOTER //
// ./src/js/render/fvRenderMove.js